import Vue from 'vue'
import VueRouter from 'vue-router'
import HelloWorld from '../components/HelloWorld.vue'
import HomeView from '../views/HomeView.vue'
import DeskMynt from '../views/DeskMynt.vue'
import MyntChangePws from '../views/MyntChangePws.vue'
import DeskMyntUAT from '@/views/DeskMyntUAT.vue'
import MyntChangePwsUAT from '@/views/MyntChangePwsUAT.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'HelloWorld',
    name: 'layout',
    component: HelloWorld,
    children: [
      {
        path: '/',
        name: 'mobile',
        component: HomeView
      },
      {
        path: '/mynt',
        name: 'mynt desk',
        component: DeskMynt
      },
      {
        path: '/mynt_uat',
        name: 'mynt desk uat',
        component: DeskMyntUAT
      },
      {
        path: '/change_password',
        name: 'Change password',
        component: MyntChangePws
      },
      {
        path: '/change_password_uat',
        name: 'Change password uat',
        component: MyntChangePwsUAT
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
